<template>

  <ul>Denne siden er under oppbygging, da vår leverandør av nettbutikken brått frafallt.. <br>
  Dette påvirker naturligvis ikke tjenesten. Logg inn i dashboordet i menyen.<br>
  <br>
  I mellomtiden, for spørsmål eller bestillinger, ta kontakt, så hjelper vi deg! :)<br>
  </ul>

</template>

<script>
export default {
  name: "TrackSense"
}
</script>

<style scoped>

</style>